/* BASIC APP CONSTANTS */
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const APP_COOKIE_NAME = "APP_COOKIE_NAME";
export const USER_COOKIE_NAME = "USER_COOKIE_NAME";
export const PASS_COOKIE_NAME = "PASS_COOKIE_NAME";
export const USER_ID_COOKIE_NAME = "USER_ID_COOKIE_NAME";
export const SET_CURRENT_ROUTE = "SET_CURRENT_ROUTE";
export const SET_SIDE_MENU_STATE = "SET_SIDE_MENU_STATE";
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION";
export const CLOSE_NOTIFICATION = "CLOSE_NOTIFICATION";
export const SHOW_ACTION_MENU = "SHOW_ACTION_MENU";
export const HIDE_ACTION_MENU = "HIDE_ACTION_MENU";
export const SHOW_BOTTOM_TOOLBAR = "SHOW_BOTTOM_TOOLBAR";
export const HIDE_BOTTOM_TOOLBAR = "HIDE_BOTTOM_TOOLBAR";
export const SET_USER_LIST = "SET_USER_LIST";
export const EDIT_DISABLED_BUTTONS = "EDIT_DISABLED_BUTTONS";
export const SET_LOGS_LIST = "SET_LOGS_LIST";
export const THEME = "THEME";

/* <---- BASIC APP CONSTANTS ----> */

/* SOCKET CONSTANTS */
export const CONNECTED = "connected";
export const DISCONNECTED = "disconnected";
/* <---- SOCKET CONSTANTS ----> */

/* CONFIGURATION */
export const CONFIGURATION_FORM_TOOGLE_LOADING =
  "CONFIGURATION_FORM_TOOGLE_LOADING";
export const SET_CONFIGURATION = "SET_CONFIGURATION";
/* <---- CONFIGURATION ----> */

/* USER */
export const SET_PROFILE = "SET_PROFILE";
/* <---- USER ----> */

/* USERS */
export const ADD_NEW_USER = "ADD_NEW_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const OPEN_USER_FORM = "OPEN_USER_FORM";
export const CLOSE_USER_FORM = "CLOSE_USER_FORM";
export const EDIT_SELECTED_USER = "EDIT_SELECTED_USER";
export const USERS_FORM_TOOGLE_LOADING = "USERS_FORM_TOOGLE_LOADING";
/* <---- USERS ----> */

/* SEASON */
export const SET_SEASON_LIST = "SET_SEASON_LIST";
export const ADD_NEW_SEASON = "ADD_NEW_SEASON";
export const UPDATE_SEASON = "UPDATE_SEASON";
export const DELETE_SEASON = "DELETE_SEASON";
export const OPEN_SEASON_FORM = "OPEN_SEASON_FORM";
export const CLOSE_SEASON_FORM = "CLOSE_SEASON_FORM";
export const EDIT_SELECTED_SEASON = "EDIT_SELECTED_SEASON";
export const SEASON_FORM_TOOGLE_LOADING = "SEASON_FORM_TOOGLE_LOADING";
/* <---- SEASON ----> */

/* FORFUNDAY */
export const SET_FORFUNDAY_LIST = "SET_FORFUNDAY_LIST";
export const ADD_NEW_FORFUNDAY = "ADD_NEW_FORFUNDAY";
export const UPDATE_FORFUNDAY = "UPDATE_FORFUNDAY";
export const DELETE_FORFUNDAY = "DELETE_FORFUNDAY";
export const OPEN_FORFUNDAY_FORM = "OPEN_FORFUNDAY_FORM";
export const CLOSE_FORFUNDAY_FORM = "CLOSE_FORFUNDAY_FORM";
export const EDIT_SELECTED_FORFUNDAY = "EDIT_SELECTED_FORFUNDAY";
export const FORFUNDAY_FORM_TOOGLE_LOADING = "FORFUNDAY_FORM_TOOGLE_LOADING";
/* <---- FORFUNDAY ----> */

/* SPECIALDAY */
export const SET_SPECIALDAY_LIST = "SET_SPECIALDAY_LIST";
export const ADD_NEW_SPECIALDAY = "ADD_NEW_SPECIALDAY";
export const UPDATE_SPECIALDAY = "UPDATE_SPECIALDAY";
export const DELETE_SPECIALDAY = "DELETE_SPECIALDAY";
export const OPEN_SPECIALDAY_FORM = "OPEN_SPECIALDAY_FORM";
export const CLOSE_SPECIALDAY_FORM = "CLOSE_SPECIALDAY_FORM";
export const EDIT_SELECTED_SPECIALDAY = "EDIT_SELECTED_SPECIALDAY";
export const SPECIALDAY_FORM_TOOGLE_LOADING = "SPECIALDAY_FORM_TOOGLE_LOADING";
/* <---- SPECIALDAY ----> */

/* UPLOADEDDECK */
export const SET_UPLOADEDDECK_LIST = "SET_UPLOADEDDECK_LIST";
export const ADD_NEW_UPLOADEDDECK = "ADD_NEW_UPLOADEDDECK";
export const UPDATE_UPLOADEDDECK = "UPDATE_UPLOADEDDECK";
export const DELETE_UPLOADEDDECK = "DELETE_UPLOADEDDECK";
export const OPEN_UPLOADEDDECK_FORM = "OPEN_UPLOADEDDECK_FORM";
export const CLOSE_UPLOADEDDECK_FORM = "CLOSE_UPLOADEDDECK_FORM";
export const EDIT_SELECTED_UPLOADEDDECK = "EDIT_SELECTED_UPLOADEDDECK";
export const UPLOADEDDECK_FORM_TOOGLE_LOADING = "UPLOADEDDECK_FORM_TOOGLE_LOADING";
/* <---- UPLOADEDDECK ----> */

/* PLACARD */
export const SET_PLACARD_LIST = "SET_PLACARD_LIST";
export const ADD_NEW_PLACARD = "ADD_NEW_PLACARD";
export const UPDATE_PLACARD = "UPDATE_PLACARD";
export const DELETE_PLACARD = "DELETE_PLACARD";
export const OPEN_PLACARD_FORM = "OPEN_PLACARD_FORM";
export const CLOSE_PLACARD_FORM = "CLOSE_PLACARD_FORM";
export const EDIT_SELECTED_PLACARD = "EDIT_SELECTED_PLACARD";
export const PLACARD_FORM_TOOGLE_LOADING = "PLACARD_FORM_TOOGLE_LOADING";
/* <---- PLACARD ----> */

/* DECKPLAYED */
export const SET_DECKPLAYED_LIST = "SET_DECKPLAYED_LIST";
export const ADD_NEW_DECKPLAYED = "ADD_NEW_DECKPLAYED";
export const UPDATE_DECKPLAYED = "UPDATE_DECKPLAYED";
export const DELETE_DECKPLAYED = "DELETE_DECKPLAYED";
export const OPEN_DECKPLAYED_FORM = "OPEN_DECKPLAYED_FORM";
export const CLOSE_DECKPLAYED_FORM = "CLOSE_DECKPLAYED_FORM";
export const EDIT_SELECTED_DECKPLAYED = "EDIT_SELECTED_DECKPLAYED";
export const DECKPLAYED_FORM_TOOGLE_LOADING = "DECKPLAYED_FORM_TOOGLE_LOADING";
/* <---- DECKPLAYED ----> */

/* GAME */
export const SET_GAME_LIST = "SET_GAME_LIST";
export const ADD_NEW_GAME = "ADD_NEW_GAME";
export const UPDATE_GAME = "UPDATE_GAME";
export const DELETE_GAME = "DELETE_GAME";
export const OPEN_GAME_FORM = "OPEN_GAME_FORM";
export const CLOSE_GAME_FORM = "CLOSE_GAME_FORM";
export const EDIT_SELECTED_GAME = "EDIT_SELECTED_GAME";
export const GAME_FORM_TOOGLE_LOADING = "GAME_FORM_TOOGLE_LOADING";
/* <---- GAME ----> */

/* ROUND */
export const SET_ROUND_LIST = "SET_ROUND_LIST";
export const ADD_NEW_ROUND = "ADD_NEW_ROUND";
export const UPDATE_ROUND = "UPDATE_ROUND";
export const DELETE_ROUND = "DELETE_ROUND";
export const OPEN_ROUND_FORM = "OPEN_ROUND_FORM";
export const CLOSE_ROUND_FORM = "CLOSE_ROUND_FORM";
export const EDIT_SELECTED_ROUND = "EDIT_SELECTED_ROUND";
export const ROUND_FORM_TOOGLE_LOADING = "ROUND_FORM_TOOGLE_LOADING";
/* <---- ROUND ----> */

/* DAY */
export const SET_DAY_LIST = "SET_DAY_LIST";
export const ADD_NEW_DAY = "ADD_NEW_DAY";
export const UPDATE_DAY = "UPDATE_DAY";
export const DELETE_DAY = "DELETE_DAY";
export const OPEN_DAY_FORM = "OPEN_DAY_FORM";
export const CLOSE_DAY_FORM = "CLOSE_DAY_FORM";
export const EDIT_SELECTED_DAY = "EDIT_SELECTED_DAY";
export const DAY_FORM_TOOGLE_LOADING = "DAY_FORM_TOOGLE_LOADING";
/* <---- DAY ----> */

/* DECKTYPE */
export const SET_DECKTYPE_LIST = "SET_DECKTYPE_LIST";
export const ADD_NEW_DECKTYPE = "ADD_NEW_DECKTYPE";
export const UPDATE_DECKTYPE = "UPDATE_DECKTYPE";
export const DELETE_DECKTYPE = "DELETE_DECKTYPE";
export const OPEN_DECKTYPE_FORM = "OPEN_DECKTYPE_FORM";
export const CLOSE_DECKTYPE_FORM = "CLOSE_DECKTYPE_FORM";
export const EDIT_SELECTED_DECKTYPE = "EDIT_SELECTED_DECKTYPE";
export const DECKTYPE_FORM_TOOGLE_LOADING = "DECKTYPE_FORM_TOOGLE_LOADING";
/* <---- DECKTYPE ----> */

/* DECK */
export const SET_DECK_LIST = "SET_DECK_LIST";
export const ADD_NEW_DECK = "ADD_NEW_DECK";
export const UPDATE_DECK = "UPDATE_DECK";
export const DELETE_DECK = "DELETE_DECK";
export const OPEN_DECK_FORM = "OPEN_DECK_FORM";
export const CLOSE_DECK_FORM = "CLOSE_DECK_FORM";
export const EDIT_SELECTED_DECK = "EDIT_SELECTED_DECK";
export const DECK_FORM_TOOGLE_LOADING = "DECK_FORM_TOOGLE_LOADING";
/* <---- DECK ----> */

/* PLAYER */
export const SET_PLAYER_LIST = "SET_PLAYER_LIST";
export const ADD_NEW_PLAYER = "ADD_NEW_PLAYER";
export const UPDATE_PLAYER = "UPDATE_PLAYER";
export const DELETE_PLAYER = "DELETE_PLAYER";
export const OPEN_PLAYER_FORM = "OPEN_PLAYER_FORM";
export const CLOSE_PLAYER_FORM = "CLOSE_PLAYER_FORM";
export const EDIT_SELECTED_PLAYER = "EDIT_SELECTED_PLAYER";
export const PLAYER_FORM_TOOGLE_LOADING = "PLAYER_FORM_TOOGLE_LOADING";
/* <---- PLAYER ----> */

/* ROUTES */
export const SET_ALL_ROUTES = "SET_ALL_ROUTES";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
/* <---- ROUTES ----> */

/* ALERT */
export const SET_ALERT_LIST = "SET_ALERT_LIST";
export const ADD_NEW_ALERT = "ADD_NEW_ALERT";
export const UPDATE_ALERT = "UPDATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";
export const OPEN_ALERT_FORM = "OPEN_ALERT_FORM";
export const CLOSE_ALERT_FORM = "CLOSE_ALERT_FORM";
export const EDIT_SELECTED_ALERT = "EDIT_SELECTED_ALERT";
export const ALERT_FORM_TOOGLE_LOADING = "ALERT_FORM_TOOGLE_LOADING";
/* <---- ALERT ----> */
